import logger from '@/core/logger/logger';
import type { App } from 'vue';
import { type LogArgument } from 'rollbar';

export default {
    install(app: App) {
      app.config.errorHandler = (error, vm, info) => {
        logger.error(error as LogArgument, { info });
      };
      app.provide('rollbar', logger);
    },
  };
